/** FHIR Communication.priority values used on MedCom CareCommunication. */
export type CareCommunicationPriority = 'routine' | 'asap';

/**
 * Read-only map of FHIR Communication.priority / list DTO priority.
 * Unknown values (including FHIR urgent/stat) are not shown.
 */
export function readCareCommunicationPriority(
  value: unknown,
): CareCommunicationPriority | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toLowerCase();
  switch (normalized) {
    case 'asap':
      return 'asap';
    case 'routine':
      return 'routine';
    default:
      return null;
  }
}

export function isAsapPriority(value: unknown): boolean {
  return readCareCommunicationPriority(value) === 'asap';
}
